import { CHANNEL } from 'src/data/channel';
import { ADS_CHANNELS, REVIEWS_CHANNELS, WEBSITE_CHANNELS } from 'src/data/performance';
import { GENERATION_TOOL_GROUP } from 'src/data/generationTool';
import { ChannelHomepageIcon } from 'src/assets/icons/ChannelHomepage';
import { ChannelLandingPagesIcon } from 'src/assets/icons/ChannelLandingPages';
import { TrustpilotIcon } from 'src/assets/icons/ChannelTrustpilot';
import { AmazonIcon } from 'src/assets/icons/ChannelAmazon';
import ChannelGoogle from 'src/assets/icons/ChannelGoogle';
import { MetaIcon } from 'src/assets/icons/ChannelMeta';
import { IconLinkedin } from 'src/assets/icons/generationTools/IconLinkedin';

export const MAX_DOCUMENT_WIDTH = 1100;
export const TOOLBAR_HEIGHT = 72;

export const DISPLAY_MODE = {
  document: 'document',
  list: 'list',
};

export const clampDisplayMode = (mode, defaultMode = null) => {
  const values = Object.values(DISPLAY_MODE);
  if (values.includes(mode)) {
    return mode;
  }
  return defaultMode;
};

export const PUBSUB_TOPIC_FILL_GUIDANCE_MODE_DATA = Symbol('TOPIC_FILL_GUIDANCE_MODE_DATA');

export const DOCUMENT_POPUP = {
  generationTool: 'generation_tool',
  onboardingBrief: 'onboarding_brief',
};

export const SIDEBAR_GENERIC_ITEM = {
  search: 'search',
  mostPopular: 'most_popular',
  moreItems: 'more_items',
};

export const SIDEBAR_TOOL_GROUPS = [
  GENERATION_TOOL_GROUP.anyCopy,
  GENERATION_TOOL_GROUP.ads,
  GENERATION_TOOL_GROUP.landingPage,
  GENERATION_TOOL_GROUP.social,
  GENERATION_TOOL_GROUP.email,
  GENERATION_TOOL_GROUP.productListing,
  GENERATION_TOOL_GROUP.generalWriting,
];

export const GENERATE_USING_OPTIONS = {
  defaultSuggestion: 'Default suggestion',
  removedTalkingPoints: 'Removed talking points',
  manualInstructions: 'Manual instructions',
};

export const DEFAULT_SUGGEST_IMPROVEMENT = 'Add engaging adjectives and verbs';

export const MANUAL_SUGGEST_IMPROVEMENT = 'Add your own instructions';

export const IMPORT_BRIEF_SOURCE = {
  fromUrl: 'from_url',
  brandBrief: 'brand_brief',
};

const ADS_ORIGIN = ADS_CHANNELS.reduce((a, v) => ({ ...a, [v]: v }), {});
const REVIEWS_ORIGIN = REVIEWS_CHANNELS.reduce((a, v) => ({ ...a, [v]: v }), {});
const WEBSITE_ORIGIN = WEBSITE_CHANNELS.reduce((a, v) => ({ ...a, [v]: v }), {});

export const SUGGESTED_ANNOTATIONS_ORIGIN = {
  anyword: 'anyword',
  ...ADS_ORIGIN,
  ...REVIEWS_ORIGIN,
  ...WEBSITE_ORIGIN,
};

export const USER_ANNOTATIONS_ORIGIN = 'user';

const SUGGESTED_ANNOTATIONS_ORIGIN_PROPS = {
  [SUGGESTED_ANNOTATIONS_ORIGIN.anyword]: {
    label: "Anyword's suggestions",
  },
  [SUGGESTED_ANNOTATIONS_ORIGIN[CHANNEL.google]]: {
    label: 'Google Ads',
    icon: ChannelGoogle,
  },
  [SUGGESTED_ANNOTATIONS_ORIGIN[CHANNEL.facebook]]: {
    label: 'Meta Ads',
    icon: MetaIcon,
  },
  [SUGGESTED_ANNOTATIONS_ORIGIN[CHANNEL.linkedin]]: {
    label: 'LinkedIn Ads',
    icon: IconLinkedin,
  },
  [SUGGESTED_ANNOTATIONS_ORIGIN[CHANNEL.amazon]]: {
    label: 'Amazon Reviews',
    icon: AmazonIcon,
  },
  [SUGGESTED_ANNOTATIONS_ORIGIN[CHANNEL.trustpilot]]: {
    label: 'Trustpilot Reviews',
    icon: TrustpilotIcon,
  },
  [SUGGESTED_ANNOTATIONS_ORIGIN[CHANNEL.homepage]]: {
    label: 'Homepage',
    icon: ChannelHomepageIcon,
  },
  [SUGGESTED_ANNOTATIONS_ORIGIN[CHANNEL.landingPages]]: {
    label: 'Landing Pages',
    icon: ChannelLandingPagesIcon,
  },
};

export const getSuggestedAnnotationsOriginLabel = (origin) =>
  SUGGESTED_ANNOTATIONS_ORIGIN_PROPS[origin].label;

export const getSuggestedAnnotationsOriginIcon = (origin) =>
  SUGGESTED_ANNOTATIONS_ORIGIN_PROPS[origin].icon;

export const getDefaultSuggestedAnnotationsOrigin = (isAppModeInfinity) =>
  isAppModeInfinity
    ? SUGGESTED_ANNOTATIONS_ORIGIN[CHANNEL.homepage]
    : SUGGESTED_ANNOTATIONS_ORIGIN.anyword;
